import axios from 'axios';
import { getAuthProvider } from '../authentication/authProvider';

export const getCountries = async () => {
  const token = await getAuthProvider().getIdToken();
  return await axios.get("api/countries", {
    headers: { "Authorization": `Bearer ${token.idToken.rawIdToken}` }
  });
};
